import { getSupabaseClient } from './supabase';
import type {
  NotificationTemplate,
  NotificationAudience,
  CreateNotificationTemplate,
  UpdateNotificationTemplate
} from '@types';

export async function fetchNotificationTemplates(audience: NotificationAudience): Promise<NotificationTemplate[]> {
  const supabase = getSupabaseClient();

  const { data, error } = await supabase
    .from('notification_templates')
    .select('*')
    .eq('audience', audience)
    .order('key', { ascending: true });

  if (error) {
    console.error('Error fetching notification templates:', error);
    throw error;
  }

  return data || [];
}

export async function createNotificationTemplate(template: CreateNotificationTemplate): Promise<NotificationTemplate> {
  const supabase = getSupabaseClient();

  const { data, error } = await supabase
    .from('notification_templates')
    .insert(template)
    .select()
    .single();

  if (error) {
    console.error('Error creating notification template:', error);
    throw error;
  }

  return data;
}

export async function updateNotificationTemplate(
  id: string,
  updates: UpdateNotificationTemplate
): Promise<NotificationTemplate> {
  const supabase = getSupabaseClient();

  const { data, error } = await supabase
    .from('notification_templates')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    console.error('Error updating notification template:', error);
    throw error;
  }

  return data;
}

export async function deleteNotificationTemplate(id: string): Promise<void> {
  const supabase = getSupabaseClient();

  const { error } = await supabase
    .from('notification_templates')
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting notification template:', error);
    throw error;
  }
}
